//ExternalLinkService.ts
import { axiosRequest } from '../AxiosService';
import { ExternalLinkResponse,ExternalLinkResponseList } from '../../type/response/ExternalLinkResponse';
import { ExternalLinkType } from '../../components/CustomMenu/Drawer/ExternalLinkType';

/**
 * 外部リンク一覧データを取得し、表示順に並び替えて返す
 * @returns 外部リンク一覧データ、取得失敗時は空配列
 */
export const fetchExternalLinks = async (): Promise<ExternalLinkType[]> => {
  try {
    const response = await axiosRequest<ExternalLinkResponseList>(
      "/externalLinks",
      "GET"
    );

    if (!Array.isArray(response)) {
      console.error("予期しないAPIレスポンス形式です:", response);
      return [];
    }

    const formattedLinks: ExternalLinkType[] = response
      .map((externalLinkResponse: ExternalLinkResponse) => {
        return {
          id: externalLinkResponse.id,
          linkName: externalLinkResponse.linkName,
          url: externalLinkResponse.url,
          linkOrder: externalLinkResponse.linkOrder,
        };
      })
      .sort((a, b) => a.linkOrder - b.linkOrder);

    return formattedLinks;
  } catch (error) {
    console.error("外部リンクデータの取得・整形に失敗しました:", error);
    return [];
  }
};